import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.251 0.25)",
		children: [
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("line", {
				x1: 8.2,
				y1: 11.4,
				x2: 8.2,
				y2: .9,
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}) }),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9,8.8l-2.6,2.6L5.6,8.8",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M13.4,3.1c2.9,2.9,2.9,7.5,0,10.4s-7.5,2.9-10.4,0s-2.9-7.5,0-10.4c0,0,0,0,0,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}) })
		]
	})
});
export { SvgCircleArrowDown as ReactComponent };
